import Router from 'vue-routes-generator'
import Main from './Main'
import Editor from './components/editor/editor'

export default {
	install: () => {
		Router.route('/main').child('escaletas', {
			name: 'Escaletas',
			component: Main
		})

		Router.route('/main').child('escaletas').child('', {
			name: 'Editor de escaletas',
			component: Editor
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/escaletas/vue/index.js